"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnDescriptionDialog = exports.InheritedRowDetails = void 0;
const tslib_1 = require("tslib");
const catalog_icons_1 = require("@tableau/catalog-icons");
const catalog_messages_1 = require("@tableau/catalog-messages");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const SharedDialogTelemetry_1 = require("../telemetry/SharedDialogTelemetry");
const TelemetryContext_1 = require("../telemetry/TelemetryContext");
const TelemetrySender_1 = require("../telemetry/TelemetrySender");
const ColumnDescriptionDialogStyles_1 = require("./ColumnDescriptionDialogStyles");
function InheritedRowDetails(props) {
    if (props.value == null) {
        return null;
    }
    return (react_1.default.createElement(ColumnDescriptionDialogStyles_1.InheritedRow, null,
        react_1.default.createElement(ColumnDescriptionDialogStyles_1.InheritedDetailsLabel, null,
            props.label,
            " ",
            props.icon || null),
        react_1.default.createElement(ColumnDescriptionDialogStyles_1.InheritedDetailsValue, null, props.value)));
}
exports.InheritedRowDetails = InheritedRowDetails;
class ColumnDescriptionDialog extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.displayStartTime = Date.now();
        this.sentDialogClosedTelemetry = false;
        this.sendDialogClosedTelemetry = () => {
            if (this.sentDialogClosedTelemetry)
                return;
            const displayEndTime = Date.now();
            const displayDuration = displayEndTime - this.displayStartTime;
            const typeOfDataDisplayed = 'column-description';
            const telemetryEnvironment = (0, TelemetryContext_1.getTelemetryEnvironmentEnumValueFromString)(this.props.telemetryEnvironment);
            const dialogReleaseVersion = this.props.tableauVersion;
            const siteLuid = this.props.siteLuid;
            const telemetryContext = {
                telemetryEnvironment: telemetryEnvironment,
                dialogReleaseVersion: dialogReleaseVersion,
                siteLuid: siteLuid,
            };
            if (this.props.telemetryContractApi) {
                TelemetrySender_1.telemetrySender.setTelemetryContractApiCallback(this.props.telemetryContractApi);
                SharedDialogTelemetry_1.sharedDialogTelemetry.sendDataDisplayedInSharedDialog(typeOfDataDisplayed, displayDuration, telemetryContext);
            }
            this.sentDialogClosedTelemetry = true;
        };
        this.onClose = () => {
            this.sendDialogClosedTelemetry();
            this.props.onClose();
        };
    }
    componentWillUnmount() {
        this.sendDialogClosedTelemetry();
    }
    render() {
        const shouldShowInheritedDetails = !!this.props.inheritedColumnName || !!this.props.assetParent;
        const dialogTitle = `${catalog_messages_1.Messages.ColumnDescription()}: ${this.props.fieldName}`;
        const content = (react_1.default.createElement(ColumnDescriptionDialogStyles_1.ColumnDescriptionPane, null,
            react_1.default.createElement(ColumnDescriptionDialogStyles_1.ColumnDescriptionFieldName, null, this.props.fieldName),
            react_1.default.createElement(ColumnDescriptionDialogStyles_1.ColumnDescriptionCell, null,
                react_1.default.createElement(ColumnDescriptionDialogStyles_1.DescriptionLabel, null, catalog_messages_1.Messages.Description()),
                react_1.default.createElement(ColumnDescriptionDialogStyles_1.DescriptionText, null, this.props.description)),
            shouldShowInheritedDetails && this.renderInheritanceDetails()));
        if (this.props.isForHybridDialog) {
            return (react_1.default.createElement(ColumnDescriptionDialogStyles_1.ColumnDescriptionWrapper, null, content));
        }
        // todo afeyissa tfsid-1434748
        // investigate the effects of not using the dialogwidget wrapper for
        // non-hybrid contexts (eg WebAuth) and remove if not necessary.
        return (react_1.default.createElement(widgets_1.DialogWidget, { anchorEl: this.props.anchorEl, anchorOrigin: {
                vertical: widgets_1.VerticalOriginOption.top,
                horizontal: widgets_1.HorizontalOriginOption.right,
            }, dialogBodyStyle: ColumnDescriptionDialogStyles_1.DescriptionDialogBodyStyle, dialogWidth: ColumnDescriptionDialogStyles_1.dialogWidth, disableAutoFocus: true, isModal: false, onCloseRequest: this.onClose, positioningBehavior: widgets_1.DialogPositioningBehavior.Anchored, showCloseButton: false, showFooter: false, testId: 'column-description', title: dialogTitle, type: widgets_1.DialogType.Uber }, content));
    }
    renderInheritanceDetails() {
        return (react_1.default.createElement(ColumnDescriptionDialogStyles_1.ColumnDescriptionCell, null,
            !!this.props.inheritedColumnName && (react_1.default.createElement(ColumnDescriptionDialogStyles_1.ColumnDescriptionInheritedColumnRow, null,
                react_1.default.createElement(InheritedRowDetails, { label: catalog_messages_1.Messages.DescriptionInheritanceColumnLabel(), value: this.props.inheritedColumnName }))),
            !!this.props.assetParent && this.renderAssetParent()));
    }
    renderAssetParent() {
        let label = null;
        let icon;
        switch (this.props.assetParent.contentType) {
            case 'datasource':
                label = catalog_messages_1.Messages.DescriptionInheritanceDatasourceLabel();
                icon = this.props.assetParent.isCertified
                    ? (react_1.default.createElement(catalog_icons_1.SvgDatasourceCertified14Px, { style: {
                            padding: '0 3px',
                            verticalAlign: 'top',
                        } }))
                    : (react_1.default.createElement(catalog_icons_1.SvgDatasource14Px, { style: {
                            padding: '0 3px',
                            verticalAlign: 'top',
                        } }));
                break;
            case 'table':
                label = catalog_messages_1.Messages.DescriptionInheritanceTableLabel();
                icon = this.props.assetParent.isCertified
                    ? react_1.default.createElement(catalog_icons_1.SvgTableCertified14Px, { style: ColumnDescriptionDialogStyles_1.AssetParentIconStyle })
                    : react_1.default.createElement(catalog_icons_1.SvgTable14Px, { style: ColumnDescriptionDialogStyles_1.AssetParentIconStyle });
                break;
            default:
                return;
        }
        return (react_1.default.createElement(ColumnDescriptionDialogStyles_1.ColumnDescriptionInheritedColumnRow, null,
            react_1.default.createElement(InheritedRowDetails, { label: label, value: this.props.assetParent.name, icon: icon })));
    }
}
exports.ColumnDescriptionDialog = ColumnDescriptionDialog;
//# sourceMappingURL=ColumnDescriptionDialog.js.map